import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { getBrUID2Cookie } from './useBloomreachSearch';
import type { HttpParams } from '../../utils/url-utils';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { BloomreachRecommendationsResponse } from './model/BloomreachRecommendationsResponse';
import type { RecommendationParams } from './model/RecommendationParams';

export const useRecommendation = ({
    widgetType,
    widgetId,
    productId,
    categoryId,
    productTypeFilter = 'hardgood',
    brandCategoryId,
    collectionId,
    maxResults,
    userId,
}: RecommendationParams): UseQueryResult<
    BloomreachRecommendationsResponse,
    BFFHttpError | null
> => {
    const brUID2 = getBrUID2Cookie();

    const params = [
        { widgetType },
        { widgetId },
        { productTypeFilter },
        { maxResults },
        { brUID2 },
    ] as HttpParams;

    const keys = [BffQueryKey.BLOOMREACH_RECOMMENDATION, widgetType, widgetId];

    if (productId) {
        params.push({ productId });
        keys.push(productId);
    }

    if (categoryId) {
        params.push({ categoryId });
        keys.push(categoryId);
    }

    if (brandCategoryId) {
        params.push({ brandCategoryId });
        keys.push(brandCategoryId);
    }

    if (collectionId) {
        params.push({ collectionId });
        keys.push(collectionId);
    }

    if (userId) {
        params.push({ userId });
        keys.push(userId);
    }

    return useBffGet<BloomreachRecommendationsResponse>(
        'bloomreach/recommendations',
        params,
        keys,
        {
            enabled: !!widgetId,
        },
    );
};
